export default "__VITE_ASSET__DTrYlje___"